import { numericSort } from 'Shared/components/Table';
import { TableCellInteger, TableCellLink, TableCellNumeric, TableCellPValue, } from 'Shared/components/Table/formatters';
import { PHENOTYPE_LINK_COLUMN_WIDTH } from 'Shared/components/Table/consts';
import styles from 'Shared/components/Table/components/TableView/TableView.css';
import { ELevelResult, ETraitsTypes } from 'Shared/types';
import createTableLinkCell from 'Common/components/Table/factories/createTablePhenotypeLink/createTablePhenotypeLink';
import { PhenotypeViewRoute } from 'Router/index';
export var ETableColumnAccessor;
(function (ETableColumnAccessor) {
    ETableColumnAccessor["Phenotype"] = "phenotype";
    ETableColumnAccessor["PValue"] = "pvalue";
    ETableColumnAccessor["NoSamples"] = "noSamples";
    ETableColumnAccessor["Cases"] = "cases";
    ETableColumnAccessor["Controls"] = "controls";
    ETableColumnAccessor["EffectSize"] = "effectSize";
    ETableColumnAccessor["EffectSizeStandardError"] = "effectSizeStandardError";
    ETableColumnAccessor["EffectSizeLCI"] = "effectSizeLCI";
    ETableColumnAccessor["EffectSizeUCI"] = "effectSizeUCI";
})(ETableColumnAccessor || (ETableColumnAccessor = {}));
/**
 * Get table columns
 *
 * @param descriptions - Text descriptions for the columns
 * @param referrerData - Referrer data for the variants link
 * @param associationData - Associations data for the variants link
 * @returns formatted table columns
 */
export const getTableColumns = (descriptions, referrerData, columnsData) => [
    {
        Header: 'Phenotype',
        accessor: ETableColumnAccessor.Phenotype,
        className: styles.alignLeft,
        Cell: TableCellLink({
            route: PhenotypeViewRoute,
            additionalData: columnsData,
            levelResult: ELevelResult.Phenotype,
            traitsType: ETraitsTypes.Binary,
            referrerData,
        }, createTableLinkCell),
        width: PHENOTYPE_LINK_COLUMN_WIDTH,
        fixed: true,
        exported: false,
    },
    {
        Header: 'P value',
        accessor: ETableColumnAccessor.PValue,
        description: descriptions[ETableColumnAccessor.PValue],
        Cell: TableCellPValue,
        sortType: numericSort,
        className: styles.alignLeft,
    },
    {
        Header: 'No. samples',
        accessor: ETableColumnAccessor.NoSamples,
        description: descriptions[ETableColumnAccessor.NoSamples],
        Cell: TableCellInteger,
        sortType: numericSort,
        className: styles.alignRight,
    },
    {
        Header: 'No. cases',
        accessor: ETableColumnAccessor.Cases,
        description: descriptions[ETableColumnAccessor.Cases],
        Cell: TableCellInteger,
        sortType: numericSort,
        className: styles.alignRight,
    },
    {
        Header: 'No. controls',
        accessor: ETableColumnAccessor.Controls,
        description: descriptions[ETableColumnAccessor.Controls],
        Cell: TableCellInteger,
        sortType: numericSort,
        className: styles.alignRight,
    },
    {
        Header: 'Effect size',
        accessor: ETableColumnAccessor.EffectSize,
        description: descriptions[ETableColumnAccessor.EffectSize],
        Cell: TableCellNumeric,
        sortType: numericSort,
        className: styles.alignRight,
    },
    {
        Header: 'Effect size standard error',
        accessor: ETableColumnAccessor.EffectSizeStandardError,
        description: descriptions[ETableColumnAccessor.EffectSizeStandardError],
        Cell: TableCellNumeric,
        sortType: numericSort,
        className: styles.alignRight,
    },
    {
        Header: 'Effect size LCI',
        accessor: ETableColumnAccessor.EffectSizeLCI,
        description: descriptions[ETableColumnAccessor.EffectSizeLCI],
        Cell: TableCellNumeric,
        sortType: numericSort,
        className: styles.alignRight,
    },
    {
        Header: 'Effect size UCI',
        accessor: ETableColumnAccessor.EffectSizeUCI,
        description: descriptions[ETableColumnAccessor.EffectSizeUCI],
        Cell: TableCellNumeric,
        sortType: numericSort,
        className: styles.alignRight,
    },
];
